import './App.css'
import { Space, RadioGroup, Radio, Row, Col, Image } from '@douyinfe/semi-ui'
import { useState } from 'react'

function App() {
  const imgList = [
    [
      { name: '直道', url: require('./assets/image/1.1直道.gif') },
      { name: '直道', url: require('./assets/image/1.2直道.gif') },
      { name: '直道', url: require('./assets/image/1.3直道.gif') },
      { name: '直道', url: require('./assets/image/1.4直道.gif') },
    ],
    [
      { name: '十字路口_直行', url: require('./assets/image/2.1十字路口_直行.gif') },
      { name: '十字路口_直行', url: require('./assets/image/2.2十字路口_直行.gif') },
      { name: '十字路口_转弯', url: require('./assets/image/2.3十字路口_转弯.gif') },
      { name: '十字路口_转弯', url: require('./assets/image/2.4十字路口_转弯.gif') },
      { name: '十字路口_转弯', url: require('./assets/image/2.4十字路口_转弯.gif') },
    ],
    [
      { name: 'T字路口_直行', url: require('./assets/image/3.1T字路口_直行.gif') },
      { name: 'T字路口_直行', url: require('./assets/image/3.2T字路口_直行.gif') },
      { name: 'T字路口_转弯', url: require('./assets/image/3.3T字路口_转弯.gif') },
      { name: 'T字路口_转弯', url: require('./assets/image/3.4T字路口_转弯.gif') },
      { name: 'T字路口_转弯', url: require('./assets/image/3.4T字路口_转弯.gif') },
    ],
    [
      { name: '变道', url: require('./assets/image/4.1变道.gif') },
      { name: '变道', url: require('./assets/image/4.2变道.gif') },
      { name: '变道', url: require('./assets/image/4.3变道.gif') },
    ],
    [{ name: '左转道', url: require('./assets/image/5.1左转道.gif') }],
    [{ name: '超车', url: require('./assets/image/6.1超车.gif') }],
  ]
  const [trafficRoadType, setTrafficRoadType] = useState('0')
  const [thumbnailList, setThumbnailList] = useState(imgList[0])
  const [currentImg, setCurrentImg] = useState(imgList[0][0].url)
  const imgStyle = { marginRight: '10px', border: '1px solid rgb(196 190 190)', cursor: 'pointer', borderRadius: '3px' }

  return (
    <>
      <div style={{ width: '593px', margin: '5px auto 0 auto' }}>
        <Image src={currentImg} height={550} style={{ border: '1px solid rgb(196 190 190)', margin: '0 auto' }} />
        <Row style={{ marginTop: '20px' }} type="flex" justify="center">
          <Col span={24}>
            <Space>
              <div>道路类型: </div>
              <RadioGroup
                onChange={(e) => {
                  setTrafficRoadType(e.target.value)
                  const copyImgList = imgList[parseInt(e.target.value)].slice()
                  setThumbnailList(copyImgList)
                  setCurrentImg(copyImgList[0].url)
                }}
                value={trafficRoadType}
              >
                <Radio value="0">直道</Radio>
                <Radio value="1">十字路口</Radio>
                <Radio value="2">T字路口</Radio>
                <Radio value="3">变道</Radio>
                <Radio value="4">左转道</Radio>
                <Radio value="5">超车</Radio>
              </RadioGroup>
            </Space>
          </Col>
        </Row>

        <Row type="flex" justify="center">
          <Col>
            <Space style={{ marginTop: '20px' }}>
              {thumbnailList.map((item, index) => {
                return (
                  <div
                    key={item.name + index}
                    style={imgStyle}
                    onClick={() => {
                      setCurrentImg(item.url)
                    }}
                  >
                    <Image src={item.url} width={80} height={80} alt={item.name} preview={false} />
                  </div>
                )
              })}
            </Space>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default App
